import { ACTIONS, FormObject, reducer } from './reducer';
import type { GetArrayReturnType } from './utils';
import { getArrayFromFields, getArrayFromState } from './utils';
import {
    isCheckboxCLicked,
    isRequired,
    isValidEmail,
    isValidPhone,
    isValidUstid,
    isValidZipGermany,
    isValidZip
} from './validationFilter';

const validationFilter = {
    isValidEmail,
    isRequired,
    isValidZipGermany,
    isValidZip,
    isValidPhone,
    isValidUstid,
    isCheckboxCLicked
};

export { ACTIONS, reducer as formReducer, getArrayFromFields, getArrayFromState, validationFilter };

export type { FormObject, GetArrayReturnType };
